import { PermissionCheckerService } from 'abp-ng2-module';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UrlHelper, AppSessionService} from '@axilla/axilla-shared';
import { Observable } from 'rxjs';

@Injectable()
export class AppRouteGuard  {
    static tenantUrl = '/app/admin/tenants';
    static loginUrl = '/account/login';
    static orderGuideUrl = '/app/ihsc/order-guides';
    static ihscDashboardUrl = '/app/webshop/dashboard';
    static dashboardUrl = '/app/dashboard';

    private _isHost: boolean;
    public get isHost(): boolean {
        this._isHost = this._sessionService.tenantId == null;
        return this._isHost;
    }

    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        private _sessionService: AppSessionService
    ) { }

    canActivateInternal(data: any, state: RouterStateSnapshot): boolean {
        if (UrlHelper.isInstallUrl(location.href)) {
            return true;
        }

        if (!this._sessionService.user) {
            this._router.navigate([AppRouteGuard.loginUrl]);
            return false;
        }

        if (!this.isHost) {
            if (state) {
                const url = state.url;
                if (url.indexOf(AppRouteGuard.tenantUrl) >= 0) {
                    return true;
                }

                if (url.indexOf(AppRouteGuard.dashboardUrl) >= 0) {
                    if (this._permissionChecker.isGranted('Pages.App.Webshop.OrderGuide.ReadOnlyAccess') &&
                        !this._permissionChecker.isGranted('Pages.App.Webshop.OrderGuide.View')) {
                        this._router.navigate([AppRouteGuard.ihscDashboardUrl]);
                        return false;
                    }
                }

            }
        }

        if (!data || !data['permission']) {
            return true;
        }

        if (this._permissionChecker.isGranted(data['permission'])) {
            return true;
        }

        this._router.navigate([this.selectBestRoute()]);
        return false;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return true;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    canLoad(route: any): Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivateInternal(route.data, null);
    }

    selectBestRoute(): string {
        if (!this._sessionService.user) {
            return AppRouteGuard.loginUrl;
        }

        //Check if user has hasBankModule Permission/Feature and Pages.Tenants permission
        //redirect to the /app/admin/tenants
        if (this._permissionChecker.isGranted('Pages.Tenants')) {
            return AppRouteGuard.tenantUrl;
        }


        if (this._permissionChecker.isGranted('Pages.Environment.Administration.Users')) {
            return '/app/admin/users';
        }

        if (this._permissionChecker.isGranted('Pages.App.Webshop.OrderGuide.ReadOnlyAccess') &&
            !this._permissionChecker.isGranted('Pages.App.Webshop.OrderGuide.View')) {
            return AppRouteGuard.ihscDashboardUrl;
        }

        return AppRouteGuard.orderGuideUrl;
    }
}
